import { useQuery } from "@tanstack/react-query";
import { BASE_URL_DEV } from "../utils/config";

export const useGet = <T>(endpoint: string, queryKey: string[]) => {
  const fetchData = async (): Promise<T> => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No token found in localStorage");
    }

    const baseUrl = `${BASE_URL_DEV}`;
    const response = await fetch(`${baseUrl}${endpoint}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch data from ${endpoint}`);
    }

    return response.json();
  };

  return useQuery<T>({
    queryKey,
    queryFn: fetchData,
  });
};
